import { isBoolean, isNull } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { ModalService, withModal } from '@sm360/widget-commons-general';

import { OPTIONSRESOLUTIONS as MODAL } from 'build-and-quote/constants/modalNames.js';
import OptionsResolutions from 'build-and-quote/components/OptionsResolutions/OptionsResolutions.jsx';

const OptionsResolutionsWithModal = withModal(MODAL)(OptionsResolutions);
const modal = ModalService.get(MODAL);

class OptionsResolutionsRender extends React.PureComponent {
    constructor(props) {
        super(props);

        this.modal = modal;
        this.state = {
            isOnError: this.props.isOnError,
            selectionResolutions: this.props.selectionResolutions,
        };
        this.handleSettledResolutions = this.handleSettledResolutions.bind(this);
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (this.props === nextProps && this.state === nextState) {
            return;
        }

        const { isOnError } =
            (nextProps && isBoolean(nextProps.isOnError) && nextProps) ||
            (nextState && isBoolean(nextState.isOnError) && nextState);

        const { selectionResolutions } = nextProps;

        this.setState({
            isOnError,
            selectionResolutions,
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.isOnError && !isNull(nextState.selectionResolutions)) {
            this.modal.open();
        } else {
            this.modal.close();
        }
    }

    handleSettledResolutions() {
        this.setState({
            isOnError: false,
        });
    }

    render() {
        const modalStyles = {
            overlay: {
                zIndex: 9999,
                backgroundColor: 'rgba(255, 255, 255, 0.75)',
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                background: '#fff',
                overflowY: 'auto',
                maxHeight: '70vh',
                maxWidth: '700px',
            },
        };

        const modalOptions = {
            contentLabel: 'optionsresolutions section dialog',
            style: modalStyles,
            shouldCloseOnOverlayClick: false,
        };
        const { handleSettledResolutions } = this.handleSettledResolutions;
        const props = {
            ...this.props,
            ...this.state,
            handleSettledResolutions,
        };
        return (
            <div>
                <OptionsResolutionsWithModal {...props} modal={modalOptions} />
            </div>
        );
    }
}

OptionsResolutionsRender.propTypes = {
    isOnError: PropTypes.bool.isRequired,
};

OptionsResolutionsRender.displayName = 'OptionsResolutionsRender';

export default OptionsResolutionsRender;
